import { computed, ComputedRef } from 'vue'

import { EventSettingsType } from '@mobile/database/EventSettingsRepository'
import * as app from '@mobile/globalState/app'
import { EventSettings } from '@mobile/reusables/types/EventSettings'
import router from '@mobile/router'

import { useEventInjections } from './Shared/RelationDependencies/useEventInjections'
import { CricketRelationIoCBindings } from './Sports/Cricket/CricketRelationDependencies/CricketRelationDependencies'

export function useEventSettings(type: EventSettingsType): {
  eventSettings: ComputedRef<EventSettings>
  updateSetting: (key: keyof EventSettings, value: unknown) => Promise<void>
} {
  const ioc = router.currentRoute.value.meta.ioc
  if (!ioc) {
    throw Error(
      'IoC Container has to be instantiated and injected into route meta before using event sub participants',
    )
  }

  // inject
  const { probableEvent } = useEventInjections()
  const eventSettings = ioc.get(CricketRelationIoCBindings.EventSettings)

  // methods
  async function updateSetting(key: string, value: unknown): Promise<void> {
    const settings = {
      ...eventSettings.value,
      [key]: value,
    }

    await app.state.database.eventSettingsRepository.put({
      eventId: probableEvent.value.id,
      type,
      settings,
    })

    eventSettings.value = settings
  }

  return {
    updateSetting,
    eventSettings: computed(() => eventSettings.value),
  }
}
